export default __webpack_public_path__ + "static/media/mobile_colony_status_uk.6b53a87a.png";